import React from 'react';
import {IStyledComponentBase} from 'styled-components/dist/types';

export const highlightText = (text: string, StyledComponent: IStyledComponentBase<any, any>, term: string, regex?: RegExp) => {
    text = (text || '').toString();
    if(!(regex || term.trim())) return text;
    regex = regex || new RegExp(`(${term})`, 'gi');
    const parts = text.split(regex);
    return parts.map((part, index) => {
        if(regex ? part.match(regex) : part.toLowerCase() === term.toLowerCase()) {
            return React.createElement(StyledComponent, {key: index}, part);
        }
        return part;
    });
};